module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/E-novels/e-novel-series-add/e-novel-series-add.component.css
// module id = ./src/app/E-novels/e-novel-series-add/e-novel-series-add.component.css
// module chunks = main